module.exports = __webpack_public_path__ + "static/media/KL.f417a009.jpg";